import React, { ComponentType, useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { useCaseListContext } from '../../../../shared/context/CaseListContext';
import { useProgressTrayDownloadNotifier } from '../../../../shared/hooks/caseHook';

export interface DownloadButtonProps {
  isDownloading: boolean;
  onClick(): void;
}

interface DownloadCaseButtonProps {
  caseIds: string[];
  DownloadButton: ComponentType<DownloadButtonProps>;
  onErrorDownload?(): void;
}
export const DownloadCaseButton = ({
  caseIds,
  DownloadButton,
  onErrorDownload,
}: DownloadCaseButtonProps) => {
  const { useDownloadImage, useSubscribeDownloadProgress } =
    useCaseListContext();

  const [isDownloading, setIsDownloading] = useState(false);
  const [sseKey, setSseKey] = useState(uuidv4());
  const { onStart, onProgress, onCompress, onDownload, onComplete } =
    useProgressTrayDownloadNotifier(sseKey);

  const { subscribeDownloadProgress } = useSubscribeDownloadProgress(sseKey, {
    onProgress,
    onCompress,
    onDownload,
  });

  const downloadImage = useDownloadImage(caseIds, sseKey, {
    onDownloadStart() {
      onStart();
      setIsDownloading(true);
    },
    onSuccess() {
      setSseKey(uuidv4()); // 새로운 sseKey 할당
      setIsDownloading(false);
      onComplete();
    },
    onError() {
      setIsDownloading(false);
      onErrorDownload?.();
    },
  });

  const onClickDownloadButton = useCallback(() => {
    if (caseIds.length === 0) {
      return;
    }
    downloadImage();
    subscribeDownloadProgress();
  }, [caseIds.length, downloadImage, subscribeDownloadProgress]);

  return (
    <>
      <DownloadButton
        isDownloading={isDownloading}
        onClick={onClickDownloadButton}
      />
    </>
  );
};
